module.exports = Jsw.skinUrl + "/icons/16/plesk/list-type-dynamic.png?f55b30089f0aeca5c8fadbd521e63daf";